/**
 * Budget Model
 * 
 * All monetary values (totalBudgeted, totalActual) are stored as integer pence
 * to avoid floating-point errors. Display in pounds sterling: (pence || 0) / 100
 */

export interface BudgetCategory {
  id: string;
  name: string;
  budgetedAmount: number;
  actualSpent: number;
  notes?: string;
}

/** Budget status - DRAFT, APPROVED, or CLOSED */
export enum BudgetStatus {
  Draft = 'DRAFT',
  Approved = 'APPROVED',
  Closed = 'CLOSED',
}

/** Budget type - INCOME, EXPENSE, or SAVINGS */
export enum BudgetType {
  Income = 'INCOME',
  Expense = 'EXPENSE',
  Savings = 'SAVINGS',
}

export interface Budget {
  id: string;
  ownerId: string;
  buildingId: string;
  name: string;
  startDate: string;
  endDate: string;
  budgetType: BudgetType;
  status: BudgetStatus;
  notes?: string;
  createdAt: string;
  updatedAt?: string;
  
  /** Total budgeted amount in pence (integer) */
  totalBudgeted: number;
  
  /** Total actual spent in pence (integer) */
  totalActual: number;
  
  // Legacy fields - retained for backwards compatibility
  year?: string;
  totalAmount?: number;
  actualSpent?: number;
  categories?: BudgetCategory[];
  createdBy?: string;
  approvedBy?: string;
  approvedAt?: string;
}

export interface BudgetChartData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    backgroundColor: string[];
    borderColor: string[];
    borderWidth: number;
  }[];
}